import { action } from 'typesafe-actions';
import localStorage from 'local-storage';
import { IPagination } from 'app/types/common';
import { BankAccountsActionTypes as types } from './types';

/* ********************************* APP ACTIONS ********************************* */

export const createBankAccount = (data): any => action(types.CREATE_BANK_ACCOUNT_REQUESTED, data);

export const updateBankAccount = (data): any => action(types.UPDATE_BANK_ACCOUNT_REQUESTED, data);

export const deleteBankAccount = (bankAccountId): any => action(types.UPDATE_BANK_ACCOUNT_REQUESTED, bankAccountId);

export const getBankAccount = (bankAccountId): any => action(types.GET_BANK_ACCOUNT_REQUESTED, bankAccountId);

export const getAllBankAccounts = (
  pagination: IPagination = undefined,
  compile = true,
): any => action(types.GET_ALL_BANK_ACCOUNTS_REQUESTED, { pagination, compile });

export const selectBankAccount = (bankAccountId): any => action(types.SELECT_BANK_ACCOUNT_REQUESTED, {
  currentBankAccountId: bankAccountId,
});

/* ********************************* SAGA ACTIONS ********************************* */
export const sagaActions = {
  createBankAccountPending: (payload): any => action(types.CREATE_BANK_ACCOUNT_PENDING, payload),
  createBankAccountSuccess: (response): any => action(types.CREATE_BANK_ACCOUNT_SUCCESS, {
    bankAccountsById: response.entities.bankAccounts,
    currentBankAccountId: response.result,
  }),
  updateBankAccountPending: (payload): any => action(types.UPDATE_BANK_ACCOUNT_PENDING, payload),
  updateBankAccountSuccess: (response): any => action(types.UPDATE_BANK_ACCOUNT_SUCCESS, {
    bankAccountsById: response.entities.bankAccounts,
    currentBankAccountId: response.result,
  }),
  updateBankAccountFailed: (error): any => action(types.UPDATE_BANK_ACCOUNT_FAIL, { backendErrors: error }),
  deleteBankAccountPending: (payload): any => action(types.UPDATE_BANK_ACCOUNT_PENDING, payload),
  deleteBankAccountSuccess: (response, userId): any => {
    localStorage.set(userId, { currentBankAccountId: null });

    return action(types.DELETE_BANK_ACCOUNT_SUCCESS, {
      currentBankAccountId: response,
    });
  },
  getBankAccountPending: (): any => action(types.GET_BANK_ACCOUNT_PENDING, {}),
  getBankAccountSuccess: (response): any => action(types.GET_BANK_ACCOUNT_SUCCESS, {
    bankAccountsById: response.entities.bankAccounts,
    currentBankAccountId: response.result,
  }),
  getBankAccountFailed: (error): any => action(types.GET_BANK_ACCOUNT_FAIL, { backendErrors: error }),
  deleteBankAccountFailed: (error): any => action(types.UPDATE_BANK_ACCOUNT_FAIL, { backendErrors: error }),
  getAllBankAccountsPending: (pagination): any => action(types.GET_ALL_BANK_ACCOUNTS_PENDING, { pagination }),
  getAllBankAccountsSuccess: (response, meta): any => action(types.GET_ALL_BANK_ACCOUNTS_SUCCESS, {
    bankAccountsById: response.entities.bankAccounts,
    bankAccountIds: response.result,
    meta,
  }),
  getAllBankAccountsFailed: (error): any => action(types.GET_ALL_BANK_ACCOUNTS_FAIL, { backendErrors: error }),
  createBankAccountFailed: (error): any => action(types.CREATE_BANK_ACCOUNT_FAIL, { backendErrors: error }),
};

export default null;
